const FastAPIIcon = ({ className = "w-6 h-6 text-white" }) => (
  <svg
    className={className}
    viewBox="0 0 6.35 6.35"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="currentColor"
      d="M3.175 0.534A2.64 2.632 0 0 0 0.534 3.166a2.64 2.632 0 0 0 2.641 2.632 2.64 2.632 0 0 0 2.641-2.632A2.64 2.632 0 0 0 3.175 0.534zM2.993 1.726h1.661L2.986 2.899h1.14L1.696 4.606l.528-1.172.241-.536.528-1.172z"
    />
  </svg>
);

export default FastAPIIcon;